export default __webpack_public_path__ + "static/10.05-2-1200c4807e20520e0051b8c760755c58.png";